(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var bundle = document.getElementById('ws-bundle');
    var checkoutButton = bundle && bundle.querySelector('.wsb-cta');
    var checkoutMap = {"1":"https://truegradelabs.com/de-de/cart/54796361728323:1","2":"https://truegradelabs.com/de-de/cart/54796361761091:1","3":"https://truegradelabs.com/de-de/cart/54796361793859:1"};
    var tracking = window.wzsGoogleAdsTracking || {};
    var trackingKeys = /^(utm_[a-z0-9_]+|gclid|dclid|gbraid|wbraid|fbclid|ttclid|msclkid|campaign(?:_[a-z0-9_]+)?)$/i;
    var navigationPending = false;

    function conversionDestination(label) {
      var conversionId = String(tracking.conversionId || '').trim();
      var conversionLabel = String(label || '').trim();
      if (!/^AW-\d+$/.test(conversionId) || !conversionLabel) return '';
      return conversionId + '/' + conversionLabel;
    }

    function trackThenProceed(trigger, label, proceed, resetAfterProceed) {
      if (navigationPending) return;
      navigationPending = true;
      trigger.classList.add('wzs-navigation-pending');
      trigger.setAttribute('aria-disabled', 'true');

      var completed = false;
      var fallback;
      function finish() {
        if (completed) return;
        completed = true;
        window.clearTimeout(fallback);
        proceed();
        if (resetAfterProceed) {
          navigationPending = false;
          trigger.classList.remove('wzs-navigation-pending');
          trigger.removeAttribute('aria-disabled');
        }
      }

      fallback = window.setTimeout(finish, 1200);
      var sendTo = conversionDestination(label);
      if (!sendTo || typeof window.gtag !== 'function') {
        finish();
        return;
      }

      try {
        window.gtag('event', 'conversion', {
          send_to: sendTo,
          event_callback: finish,
          event_timeout: 1200
        });
      } catch (error) {
        finish();
      }
    }

    document.querySelectorAll('a[href="#ws-bundle"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        trackThenProceed(link, tracking.addToCartLabel, function () {
          if (!bundle) return;
          bundle.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.history.replaceState(null, '', window.location.pathname + window.location.search + '#ws-bundle');
        }, true);
      });
    });

    function checkoutUrl(path) {
      var target = new URL(path, window.location.origin);
      var incoming = new URLSearchParams(window.location.search);
      incoming.forEach(function (value, key) {
        if (trackingKeys.test(key)) target.searchParams.set(key, value);
      });
      return target.href;
    }

    function selectCheckoutTier(tier) {
      if (!checkoutButton || !checkoutMap[tier]) return;
      checkoutButton.setAttribute('href', checkoutUrl(checkoutMap[tier]));
      checkoutButton.setAttribute('data-checkout-tier', tier);
    }

    if (bundle && checkoutButton) {
      bundle.querySelectorAll('.wsb-tier[data-tier]').forEach(function (tier) {
        tier.addEventListener('click', function () { selectCheckoutTier(tier.getAttribute('data-tier')); });
      });
      var selectedTier = bundle.querySelector('.wsb-tier input:checked');
      selectCheckoutTier(selectedTier ? selectedTier.value : '2');

      checkoutButton.addEventListener('click', function (event) {
        event.preventDefault();
        var target = checkoutButton.href;
        trackThenProceed(checkoutButton, tracking.beginCheckoutLabel, function () {
          window.location.assign(target);
        }, false);
      });
    }

    document.querySelectorAll('.image-slider').forEach(function (slider) {
      var main = slider.querySelector('.is-image-wrapper img');
      var thumbnails = Array.prototype.slice.call(slider.querySelectorAll('.is-thumbnail[data-img]'));
      if (!main || !thumbnails.length) return;
      var index = Math.max(0, thumbnails.findIndex(function (item) { return item.classList.contains('selected'); }));

      function show(nextIndex) {
        index = (nextIndex + thumbnails.length) % thumbnails.length;
        thumbnails.forEach(function (item, itemIndex) {
          item.classList.toggle('selected', itemIndex === index);
        });
        main.src = thumbnails[index].getAttribute('data-img');
        main.alt = thumbnails[index].querySelector('img')?.alt || 'WurzelStopp Produktansicht';
      }

      thumbnails.forEach(function (item, itemIndex) {
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.addEventListener('click', function () { show(itemIndex); });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); show(itemIndex); }
        });
      });
      slider.querySelector('.prev')?.addEventListener('click', function () { show(index - 1); });
      slider.querySelector('.next')?.addEventListener('click', function () { show(index + 1); });
      show(index);
    });

    document.querySelectorAll('.faq').forEach(function (faq) {
      var header = faq.querySelector('.faq-header');
      if (!header) return;
      function toggle() {
        faq.classList.toggle('active');
        header.setAttribute('aria-expanded', faq.classList.contains('active') ? 'true' : 'false');
      }
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
      });
    });
  });
})();

function startUniqueTimer(duration, display) {

            var timer = duration, hours, minutes, seconds;

            setInterval(function () {

                hours = parseInt(timer / 3600, 10);

                minutes = parseInt((timer % 3600) / 60, 10);

                seconds = parseInt(timer % 60, 10);

                hours = hours < 10 ? "0" + hours : hours;

                minutes = minutes < 10 ? "0" + minutes : minutes;

                seconds = seconds < 10 ? "0" + seconds : seconds;



                display.hours.textContent = hours;

                display.minutes.textContent = minutes;

                display.seconds.textContent = seconds;



                if (--timer < 0) {

                    timer = duration;

                }

            }, 1000);

        }



        window.onload = function () {

            var duration = (1 * 3600) + (27 * 60) + 38; // 1 hour, 27 minutes, and 38 seconds in seconds



            // Select desktop and mobile timers

            var desktopDisplay = {

                hours: document.querySelector('#desktop-hours'),

                minutes: document.querySelector('#desktop-minutes'),

                seconds: document.querySelector('#desktop-seconds')

            };

            var mobileDisplay = {

                hours: document.querySelector('#mobile-hours'),

                minutes: document.querySelector('#mobile-minutes'),

                seconds: document.querySelector('#mobile-seconds')

            };



            // Start timer for both mobile and desktop

            startUniqueTimer(duration, desktopDisplay);

            startUniqueTimer(duration, mobileDisplay);

        };

// Get the scroll-content div

    const scrollContent = document.getElementById('scroll-content');



    // Store the HTML of the original three items

    const originalItems = scrollContent.innerHTML;



    // Repeat the original items 99 times (for a total of 100 sets)

    for (let i = 0; i < 12; i++) {

        scrollContent.innerHTML += originalItems;

    }



    // Dynamically adjust the width of the content for continuous scrolling

    scrollContent.style.width = `${scrollContent.scrollWidth}px`;

// Feste Endzeit des Ausverkaufs festlegen

  const saleEndTime = '23:59';



  // Aktuelles Datum abrufen

  const currentDate = new Date();



  // Datum ins gewuenschte Format bringen

  const formattedDate = currentDate.toLocaleDateString('de-DE', {

    weekday: 'long',

    year: 'numeric',

    month: 'long',

    day: 'numeric',

  });



  // Ausverkaufsmeldung anzeigen

  const saleMessage = `Ausverkauf endet heute, ${formattedDate} um ${saleEndTime}`;

  document.getElementById('saleMessage').innerHTML = saleMessage;

(function(){var s=document.getElementById('ws-bundle');if(!s)return;
s.querySelectorAll('.wsb-tier').forEach(function(t){t.addEventListener('click',function(){s.querySelectorAll('.wsb-tier').forEach(function(x){x.classList.remove('sel')});t.classList.add('sel');var r=t.querySelector('input');if(r)r.checked=true;});});
var el=document.getElementById('wsb-timer');if(el){var sec=599;setInterval(function(){if(sec<=0)return;sec--;var m=Math.floor(sec/60),ss=sec%60;el.textContent=(m<10?'0':'')+m+':'+(ss<10?'0':'')+ss;},1000);}
})();
